
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetogoaurbaniaonrent() {



    const cardData =
    {
        keyword: ' Pune to Goa Urbania On Rent',
        heading: 'Samarth Travels: Pune to Goa Urbania On Rent',
        headingDescription: 'Samarth Travels offers Urbania on rent from Pune to Goa, perfect for beach holidays, group tours, and weekend getaways. Our luxurious Force Urbania vehicles feature air-conditioning, push-back seats, and spacious interiors to ensure a relaxed and enjoyable journey along the scenic route to Goa. With expert drivers, honest pricing, and a focus on comfort and safety, Samarth Travels makes your Pune to Goa trip smooth, fun, and unforgettable.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Pune to Goa Urbania on Rent",
        "description": "Samarth Travels offers premium Urbania rentals from Pune to Goa, ideal for families, friends, or corporate groups looking for comfort during their long-distance travel. Our well-maintained vans come with spacious interiors, air-conditioning, and reclining seats to ensure a smooth and enjoyable ride through scenic highways from Pune to the beaches of Goa."
    },
    {
        "name": "Urbania for Rent Pune to Goa",
        "description": "Looking to rent an Urbania from Pune to Goa? Samarth Travels provides reliable and comfortable vans for group travel. Perfect for weekend getaways or extended vacations, our vehicles offer sufficient space for passengers and luggage, with amenities like music systems and charging points to make your journey more enjoyable."
    },
    {
        "name": "Urbania Rental for Pune to Goa Trip",
        "description": "Make your Pune to Goa trip more memorable with Samarth Travels’ Urbania rental service. Our fleet is ideal for long road trips and can accommodate mid-sized to large groups with ease. Enjoy scenic views, coastal breezes, and smooth roads while traveling in a safe and cozy Urbania van driven by experienced chauffeurs."
    },
    {
        "name": "Rent Urbania for Goa Sightseeing from Pune",
        "description": "Explore Goa's beaches, forts, and nightlife with our Pune-to-Goa Urbania rental for sightseeing. Whether it’s North Goa’s vibrant vibe or South Goa’s serene spots, our Urbania vans ensure comfortable travel between tourist attractions. Book a package with us for flexible stops and a personalized itinerary."
    },
    {
        "name": "Urbania Hire for Goa Family Trip from Pune",
        "description": "Planning a family vacation to Goa from Pune? Hire a spacious Urbania van from Samarth Travels and enjoy a comfortable, connected ride. Our vehicles are perfect for all age groups, providing legroom, AC, and ample space for luggage—making the journey part of the fun."
    },
    {
        "name": "14-Seater Urbania on Rent Pune to Goa",
        "description": "Travel in comfort with our 14-seater Urbania van for your Pune to Goa journey. Ideal for medium-sized groups, this vehicle offers generous space, reclining seats, air-conditioning, and smooth suspension for the 8–10 hour road trip. It’s a cost-effective and stylish option for group tours or family holidays."
    },
    {
        "name": "Urbania for Group Travel to Goa from Pune",
        "description": "Samarth Travels specializes in group travel services with Urbania rentals from Pune to Goa. Whether you're heading to a destination wedding, corporate retreat, or student trip, our vans provide comfort, safety, and convenience for everyone on board. Enjoy traveling together and create unforgettable memories en route to Goa."
    },
    {
        "name": "Pune to Goa Urbania Rental Services",
        "description": "Get the best Urbania rental services for your Pune to Goa trip with Samarth Travels. We offer multiple seating options, luxury variants, and customizable travel plans. Our professional drivers, clean vehicles, and affordable pricing make us a top choice for long-distance road travel to Goa."
    },
    {
        "name": "Urbania Rental Price Pune to Goa",
        "description": "Curious about the cost to rent an Urbania from Pune to Goa? Samarth Travels offers competitive and transparent pricing with no hidden fees. Rates vary based on the vehicle type, trip duration, and customization. Contact us for an accurate quote tailored to your itinerary and group size."
    },
    {
        "name": "Rent Urbania for Goa Vacations",
        "description": "Enjoy the ultimate Goa vacation with a rented Urbania van from Pune. Our vans are perfect for group travel, offering flexible schedules, multiple pickup points, and scenic highway stops. Whether you're beach hopping or exploring Portuguese heritage sites, travel in comfort and convenience with Samarth Travels."
    },
    {
        "name": "Urbania Hire for Group Tours to Goa from Pune",
        "description": "Organizing a group tour to Goa? Hire an Urbania van from Samarth Travels for a relaxed and safe journey from Pune. Our vans are ideal for college trips, corporate teams, or family groups, offering AC, spacious interiors, and storage for luggage. Enjoy group travel with our well-maintained and road-trip-ready vehicles."
    },
    {
        "name": "Best Urbania on Rent Pune to Goa",
        "description": "Get the best Urbania on rent for your Pune to Goa travel needs with Samarth Travels. We offer top-rated service, clean and modern vehicles, and professional drivers to make your journey smooth and worry-free. Ideal for any occasion—family trips, holidays, or work tours—our service is designed for customer satisfaction."
    },
    {
        "name": "Goa Trip Urbania Hire from Pune",
        "description": "Plan your perfect Goa trip with Urbania hire from Pune. Our vans come with experienced drivers, comfortable seats, and spacious cabins to enhance your travel experience. Whether it’s a romantic trip, beach holiday, or adventure tour, we ensure a memorable journey from Pune to Goa with complete peace of mind."
    }
],
"tableData": [
    ["Pune to Goa Urbania on Rent", "Urbania for Rent Pune to Goa"],
    ["Urbania Rental for Pune to Goa Trip", "Rent Urbania for Goa Sightseeing from Pune"],
    ["Urbania Hire for Goa Family Trip from Pune", "14-Seater Urbania on Rent Pune to Goa"],
    ["Urbania for Group Travel to Goa from Pune", "Pune to Goa Urbania Rental Services"],
    ["Urbania Rental Price Pune to Goa", "Rent Urbania for Goa Vacations"],
    ["Urbania Hire for Group Tours to Goa from Pune", "Best Urbania on Rent Pune to Goa"],
    ["Goa Trip Urbania Hire from Pune", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania Rental Service for Pune to Goa",
        "WhyChoosedescription": "We offer dependable Force Urbania van rental services for your journey from Pune to Goa. Whether you're planning a family vacation, group outing, or corporate trip, we ensure a smooth, comfortable, and timely journey with professional drivers and well-maintained vans."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Force Urbania Vans for Long-Distance Travel",
        "WhyChoosedescription": "Our Force Urbania vans are designed for long journeys like Pune to Goa. With seating options for 9 to 17 passengers, each van is equipped with comfortable reclining seats, air-conditioning, ample legroom, and charging ports, ensuring that all passengers enjoy a relaxed and comfortable ride."
    },
    {
        "WhyChooseheading": "Professional Drivers for Safe and Punctual Travel",
        "WhyChoosedescription": "Our experienced drivers are familiar with the Pune to Goa route and ensure a safe and smooth journey. They prioritize punctuality and passenger safety, making sure you arrive on time, without any hassle or delays."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Goa Rentals",
        "WhyChoosedescription": "We offer affordable and transparent pricing for your Pune to Goa trip, with no hidden charges. Whether you need the Force Urbania for a few hours or an entire day, we provide flexible rental packages that suit your budget and travel needs."
    },
    {
        "WhyChooseheading": "24/7 Availability to Match Your Travel Schedule",
        "WhyChoosedescription": "Our Force Urbania van rentals are available 24/7, giving you the flexibility to plan your journey from Pune to Goa at any time. Whether it’s an early morning departure or a late-night return, we accommodate your preferred travel schedule."
    },
    {
        "WhyChooseheading": "Simple Booking and Real-Time Updates for Seamless Travel",
        "WhyChoosedescription": "Booking your Force Urbania rental for Pune to Goa is easy and quick. Once confirmed, you'll receive real-time tracking updates, driver contact information, and arrival details, ensuring smooth coordination and peace of mind throughout your journey."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Urbania Vans for Your Safety",
        "WhyChoosedescription": "We maintain our Force Urbania vans to the highest standards of cleanliness and safety. Every van is thoroughly cleaned and sanitized before every trip, ensuring a hygienic and comfortable environment for all passengers."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for Convenient Booking",
        "WhyChoosedescription": "We provide multiple payment methods, including UPI, credit/debit cards, digital wallets, and cash, allowing you to complete your booking securely and conveniently."
    }
]






















    }

const faqData = [
    {
        id: 1,
        question: 'How do I rent a Force Urbania for a Pune to Goa trip with Samarth Travels?',
        answer: 'Renting a Force Urbania for your Pune to Goa trip is simple. You can book by visiting our website or calling our customer support. Provide your trip details like date, number of passengers, and preferred pickup point, and we’ll take care of the rest.',
    },
    {
        id: 2,
        question: 'What are the rental rates for a Pune to Goa Urbania trip?',
        answer: 'The rental charges for a Pune to Goa trip typically range from ₹20,000 to ₹25,000 for a round trip. Pricing varies based on the seating capacity (13-seater or 17-seater), trip duration, and other factors. Tolls and taxes are additional.',
    },
    {
        id: 3,
        question: 'Is the Force Urbania suitable for long trips like Pune to Goa?',
        answer: 'Yes, the Force Urbania is designed for long journeys, making it an ideal choice for a Pune to Goa trip. With its comfortable recliner seats, air conditioning, large windows, and USB charging ports, it ensures a relaxed and enjoyable ride.',
    },
    {
        id: 4,
        question: 'How long does the Pune to Goa trip take by Urbania?',
        answer: 'The distance from Pune to Goa is approximately 450 km, and the journey typically takes around 8 to 10 hours, depending on road conditions and traffic. Our drivers are well-versed in the route, ensuring a smooth and safe journey.',
    },
    {
        id: 5,
        question: 'Can I customize my Pune to Goa Urbania rental to include sightseeing?',
        answer: 'Yes, you can customize your trip to include sightseeing in Goa. Let us know your preferred stops, such as beaches, historical sites, or famous landmarks, and we’ll adjust the itinerary accordingly.',
    },
    {
        id: 6,
        question: 'Is a one-way trip from Pune to Goa available for Urbania rental?',
        answer: 'Yes, one-way rentals are available for Pune to Goa trips. You can arrange for a convenient drop-off in Goa, and our team will ensure your return journey is smooth and well-organized.',
    },
    {
        id: 7,
        question: 'Do you provide 24/7 customer support for Pune to Goa bookings?',
        answer: 'Yes, Samarth Travels offers 24/7 customer support for all trips, including the Pune to Goa route. Whether you need assistance with booking, have questions during your journey, or require any changes, our team is always available to help.',
    },
];

const testimonials = [
    {
        name: 'Mr. Vijay Deshmukh',
        role: 'Corporate Executive',
        text: 'We rented a 17-seater Force Urbania for a corporate trip from Pune to Goa. The ride was very comfortable, and the van had all the modern amenities. The driver was professional and knowledgeable about the route. We had a fantastic time!',
        image: '/img/testimonial/testi_urbania_vijay.jpg',
    },
    {
        name: 'Mrs. Sunita Rao',
        role: 'Group Tour Organizer',
        text: 'Booked a 13-seater Urbania for a family trip to Goa from Pune. The vehicle was spacious and well-maintained, and the trip was smooth and enjoyable. We’ll definitely use Samarth Travels for our next group trip!',
        image: '/img/testimonial/testi_urbania_sunita.jpg',
    },
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Urbania On Rent",
  "image": "https://samarthtravels.com/assets/images/pune-to-goa-urbania-on-rent.jpg",
  "description": "Rent a luxury Urbania vehicle for your Pune to Goa trip. Affordable and comfortable options for family trips, group tours, and sightseeing in Goa. Available for 14-seater and other Urbania bus configurations.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "35000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-goa-urbania-on-rent"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Goa Urbania On Rent | Affordable & Luxury Bus Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury Urbania vehicle for your Pune to Goa trip. Affordable and comfortable options for family trips, group tours, and sightseeing in Goa. Available for 14-seater and other Urbania bus configurations." 
  />
  <meta 
    name="keywords" 
    content="Pune to Goa Urbania on rent, Urbania for rent Pune to Goa, Urbania rental for Pune to Goa trip, Rent Urbania for Goa sightseeing from Pune, Urbania hire for Goa family trip from Pune, 14-seater Urbania on rent Pune to Goa, Urbania for group travel to Goa from Pune, Pune to Goa Urbania rental services, Urbania rental price Pune to Goa, Rent Urbania for Goa vacations, Urbania hire for group tours to Goa from Pune, Best Urbania on rent Pune to Goa, Goa trip Urbania hire from Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoaurbaniaonrent;